// src/screens/LoanDrilldownScreen/tabs/LoanDrilldownFilesTab/LoanFilesTable/LoanFilesTable.jsx
import { ModuleRegistry } from "ag-grid-community";
import {
  ColumnsToolPanelModule,
  FiltersToolPanelModule,
  MasterDetailModule,
  MultiFilterModule,
  PivotModule,
  RowGroupingModule,
  RowGroupingPanelModule,
  SetFilterModule,
  SideBarModule,
  TreeDataModule,
} from "ag-grid-enterprise";
import { AgGridReact } from "ag-grid-react";
import { useCallback, useMemo, useRef } from "react";

import isEmpty from "lodash/isEmpty";

import { columnTypesDate } from "../../../../../_src_shared/utils/agGrid/columnTypes/columnTypesDate";
import { columnTypesDollar } from "../../../../../_src_shared/utils/agGrid/columnTypes/columnTypesDollar";
import { columnTypesNumber } from "../../../../../_src_shared/utils/agGrid/columnTypes/columnTypesNumber";
import { useSidebar } from "../../../../../_src_shared/utils/agGrid/hooks/useSidebar";
import AgGridTableWrapper from "../../../../../components/agGrid/AgGridTableWrapper";
import { useColumnDefsGlobalExceptionsTable } from "./hooks/useColumnDefsGlobalExceptionsTable";

// Import the detail cell renderer component
import DetailCellRendererLoanException from "./DetailCellRendererLoanException";

ModuleRegistry.registerModules([
  SideBarModule,
  RowGroupingPanelModule,
  MultiFilterModule,
  RowGroupingModule,
  PivotModule,
  TreeDataModule,
  FiltersToolPanelModule,
  ColumnsToolPanelModule,
  SetFilterModule,
  MasterDetailModule, // Add this for master-detail functionality
]);

const GlobalExceptionsTable = ({
  rowData,
  autoHeight,
  quickFilter,
  height = "100%",
}) => {
  const gridRef = useRef(null);
  const columnDefs = useColumnDefsGlobalExceptionsTable();
  const columnTypes = useMemo(() => {
    return {
      ...columnTypesDate(),
      ...columnTypesNumber(),
      ...columnTypesDollar(),
    };
  }, []);

  const sidebar = useSidebar();
  const detailCellRenderer = useCallback(DetailCellRendererLoanException, []);
  // Default column definition
  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      filter: true,
      resizable: true,
      autoHeight: true,
      cellClass: "ag-cell-vertical-center",
      flex: 1,
      // cellStyle: {
      //   display: "flex",
      //   alignItems: "center",
      //   justifyContent: "center", // Optional: also center horizontally
      // },
    }),
    []
  );

  // Function to get detail data for a row

  const onFirstDataRendered = useCallback((params) => {
    // arbitrarily expand a row for presentational purposes
    setTimeout(() => {
      // params.api.getDisplayedRowAtIndex(1).setExpanded(true);
    }, 0);
  }, []);

  return (
    <AgGridTableWrapper height={height} simpleTable size={4}>
      <AgGridReact
        ref={gridRef}
        rowData={rowData}
        columnDefs={columnDefs}
        columnTypes={columnTypes}
        defaultColDef={defaultColDef}
        singleClickEdit
        sideBar={sidebar}
        loading={isEmpty(rowData)}
        quickFilterText={quickFilter}
        domLayout={autoHeight ? "autoHeight" : "normal"}
        // Master-detail configuration
        masterDetail={true}
        detailCellRenderer={detailCellRenderer}
        // detailRowHeight={310}
        detailRowAutoHeight
        // detailCellRenderer={detailCellRenderer}
        onFirstDataRendered={onFirstDataRendered}
      />
    </AgGridTableWrapper>
  );
};

export default GlobalExceptionsTable;
